(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category_new-arrivals-carousel"] && !Shopify.designMode) return;
  try {
    
function initNewArrivalsSwiper() {
  if (typeof Swiper === 'undefined') return;

  new Swiper(".newArrivalsSwiper", {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1200: { slidesPerView: 3 }
    }
  });
}

/* Auto-init for live and editor */
document.addEventListener('shopify:section:load', initNewArrivalsSwiper);
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    s.onload = initNewArrivalsSwiper;
    document.head.appendChild(s);
  } else {
    initNewArrivalsSwiper();
  }
});

  } catch(e) { console.error(e); }
})();
})();
